/*
 * @Author: liyxt
 * @Date: 2019-10-14 11:19:57
 * @LastEditors: bbq
 * @LastEditTime: 2020-09-02 15:02:50
 * @Description: file content
 */
/* eslint-disable no-control-regex */
/* eslint-disable react/jsx-wrap-multilines */
//  这个组件需要根据原始需求重构  TODO  bbqin
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import Dropdown from '../Dropdown';
import NCFormControl from '../-FormControl';
import NCHotKeys from '../HotKeys';
import MultiOption from './MultiOption';
import { getSysFieldid, isArrowKeyDown, localeLang } from '@platform/api';

require('./index.less');

export default class MultiLangText extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            list: [],
            currentValue: '',
            currentIndex: 0,
        };
        this.firstFlag = true;
    }

    UNSAFE_componentWillMount() {
        this.getList(this.props, true);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // let key = attrcode + languageMeta[currentIndex].index;
        // this._currentValue是上次修改完之后的value
        // nextProps.value[key].value是这次修改完之后的value
        // if ((this._currentValue || '') !== ((nextProps.value[key] && nextProps.value[key].value) || '')) {
        // 	this.getList(nextProps);
        // }
        Object.keys(nextProps.value).some(key => {
            return (
                ((this._currentValue || {})[key] || '') !== ((nextProps.value[key] && nextProps.value[key].value) || '')
            );
        }) && this.getList(nextProps);
    }

    getList = props => {
        const { languageMeta, attrcode, value = {}, LangIndex } = props;
        let { currentIndex } = this.state;
        let list = languageMeta.map((e, i) => {
            e = { ...e };
            //如果设置了显示语种LangIndex 就优先显示
            if (this.firstFlag && LangIndex && e.index === LangIndex) {
                currentIndex = i;
            }
            //如果没有设置 需要显示的语种就显示登录语种
            if (this.firstFlag && !LangIndex && e.languageCode === localeLang) {
                currentIndex = i;
            }
            // e.key = e.index == 1 ? attrcode : attrcode + e.index;
            e.key = attrcode + e.index;
            e.value = (value[e.key] || {}).value || '';

            if (e.index == 0 || e.index == 1) {
                this.mainKey = e.key;
                this.mainIndex = e.index;
            }

            return e;
        });
        // 登录语言无值 主语言有值 展示主语言框
        if (list[currentIndex].value == '' && value[attrcode] && value[attrcode].value) {
            list.map((e, index) => {
                if (!e.index) {
                    currentIndex = index;
                }
            });
        }
        this._currentValue = props.value;
        this.setState({
            list,
            currentIndex,
            currentValue: list[currentIndex].value,
        });
    };

    close = () => {
        let { list, currentIndex, currentValue } = this.state;
        const { onBlur, attrcode } = this.props;

        list[currentIndex].value = currentValue;
        // 登陆语言的值赋给主语言
        let localeLangValue = list.find(i => i.languageCode == localeLang);
        list.forEach(item => {
            if (item.key == attrcode) {
                if (!item.value && localeLangValue && localeLangValue.value) {
                    item.value = localeLangValue.value;
                }
            }
        });
        let obj = {};
        list.forEach(e => {
            obj[e.key] = { value: e.value };
        });
        typeof onBlur === 'function' && onBlur(obj, list[currentIndex].index);
        this.setState({
            show: false,
            list,
        });
    };

    render() {
        let { show, list, currentIndex, currentValue } = this.state;
        const {
            onChange,
            onSelect,
            disabled,
            placeholder,
            autoFocus,
            maxLength,
            maxlength,
            onFocus,
            attrcode,
            fieldid,
            hotKeyWithArrow,
        } = this.props;

        let max_l = [maxLength, maxlength].find(e => e || e === 0);
        max_l === undefined && (max_l = Infinity);
        let multiLangClass = classnames({
            'multi-lang-text multi-lang-text-focus': show,
            'multi-lang-text': !show,
        });
        let dropdownClassName = 'multi-lang-text-collapse';
        let hasFieldid = getSysFieldid(fieldid);
        if (hasFieldid && (fieldid || attrcode)) {
            dropdownClassName = dropdownClassName + ` fieldid_${fieldid || attrcode}_select`;
        }
        return (
            <Dropdown
                trigger={['click']}
                overlayClassName={dropdownClassName}
                placement="bottomLeft"
                visible={show}
                overlay={
                    <ul
                        ref={dom => {
                            this.dropDown = ReactDOM.findDOMNode(dom);
                        }}
                        onMouseDown={e => {
                            e.preventDefault();
                        }}
                        style={{
                            // width: this.multiLangText && this.multiLangText.clientWidth
                        }}
                    >
                        {list.map(({ languageType, value, key }, i) => (
                            <li
                                key={key}
                                className={`multi-lang-text-item  ${currentIndex === i ? 'selected' : ''}`}
                                onClick={() => {
                                    currentIndex = i;

                                    currentValue = value;
                                    if (list[currentIndex].key == attrcode) {
                                        this.mainIsEmpty = false;
                                    }
                                    this.firstFlag = false;
                                    this.setState(
                                        {
                                            currentValue,
                                            currentIndex,
                                            // show: false
                                        },
                                        () => {
                                            typeof onSelect === 'function' &&
                                                onSelect(currentValue, list[currentIndex].index);
                                        },
                                    );
                                }}
                            >
                                <span className="multi-lang-text-prefix">{value}</span>
                                <span className="multi-lang-text-suffix">{languageType}</span>
                            </li>
                        ))}
                    </ul>
                }
            >
                <NCHotKeys
                    className={`${disabled ? 'multiLangText-disabled ' : ''} multilang-hotkeys-wrapper`}
                    attach={false}
                    display="inline-block"
                    clearOpenPanel={false}
                    keyMap={{
                        hide: ['esc', 'enter'],
                        show: ['down'],
                        down: ['down'],
                        up: ['up'],
                        ctrl: ['ctrl'],
                        // enter: ['enter'],
                    }}
                    handlers={{
                        hide: () => {
                            this.setState({ show: false });
                        },
                        // enter: e => {
                        //     // console.log(e);
                        //     this.props.onEnter && this.props.onEnter({ e });
                        // },
                        show: () => {
                            this.setState({ show: true });
                        },
                        down: e => {
                            let len = list.length;
                            let next = currentIndex + 1 >= len ? 0 : currentIndex + 1;
                            let value = list[next].value;
                            let { renderInTable, hotKeyWithArrow } = this.props;
                            let { show } = this.state;
                            if (renderInTable && !show && isArrowKeyDown(e)) {
                                hotKeyWithArrow && hotKeyWithArrow({ e });
                                return;
                            }
                            if (list[currentIndex].key == attrcode) {
                                this.mainIsEmpty = false;
                            }
                            this.firstFlag = false;
                            this.setState(
                                {
                                    currentIndex: next,
                                    currentValue: value,
                                },
                                () => {
                                    typeof onSelect === 'function' && onSelect(value, list[next].index);
                                },
                            );
                        },
                        up: e => {
                            let len = list.length - 1;
                            let next = currentIndex - 1 < 0 ? len : currentIndex - 1;
                            let value = list[next].value;
                            let { renderInTable, hotKeyWithArrow } = this.props;
                            let { show } = this.state;
                            if (renderInTable && !show && isArrowKeyDown(e)) {
                                hotKeyWithArrow && hotKeyWithArrow({ e });
                                return;
                            }
                            if (list[currentIndex].key == attrcode) {
                                this.mainIsEmpty = false;
                            }
                            this.firstFlag = false;
                            this.setState(
                                {
                                    currentIndex: next,
                                    currentValue: value,
                                },
                                () => {
                                    typeof onSelect === 'function' && onSelect(value, list[next].index);
                                },
                            );
                        },
                        ctrl: () => {
                            this.setState({ show: !this.state.show });
                        },
                    }}
                >
                    <div
                        className={multiLangClass}
                        ref={dom => {
                            this.multiLangText = dom;
                        }}
                        fieldid={fieldid || null}
                        onKeyDown={(e) => {
                            if (e.keyCode == 13) {
                                this.props.onEnter && this.props.onEnter({ e });
                            }
                        }}
                    >
                        <NCFormControl
                            itemtype="residtxt"
                            type="text"
                            value={currentValue}
                            onChange={(v, e) => {
                                let _v = v;
                                // _v = _v.replace(/[^\x00-\xff]/g, '11');
                                currentValue = v;
                                list[currentIndex].value = currentValue;
                                if (_v.length > Number(max_l) && !e.target.isFlag) {
                                    currentValue = this.state.currentValue;
                                    list[currentIndex].value = currentValue;
                                }
                                let obj = {};
                                let loginIndex;
                                list.forEach((e, i) => {
                                    if (e.languageCode == localeLang) {
                                        // 当前编辑的是登录语言且主语言没值
                                        loginIndex = i;
                                    }

                                    obj[e.key] = {
                                        value: e.value,
                                        index: e.index,
                                        current: currentIndex == i,
                                    };
                                });

                                if (currentIndex == loginIndex && this.mainIsEmpty) {
                                    // 当前编辑的是登录语言且主语言没值
                                    obj[this.mainKey] = {
                                        value: currentValue,
                                        index: this.mainIndex,
                                        current: true,
                                    }
                                }

                                // this._currentValue = currentValue;
                                typeof onChange === 'function' && onChange(obj);
                                this.setState({
                                    currentValue,
                                    list,
                                });
                            }}
                            onFocus={evt => {
                                // 登陆语言的值赋给主语言
                                let main = list.find(e => e.key === this.mainKey);
                                if (main && main.value) {
                                    this.mainIsEmpty = false;
                                } else {
                                    this.mainIsEmpty = true;
                                }

                                let { renderInTable } = this.props;
                                !renderInTable && this.setState(
                                    { show: true },
                                    () => {
                                        // onFocus && onFocus(evt, evt.target, list[currentIndex].key);
                                    },
                                );
                                onFocus && onFocus(evt, evt.target, list[currentIndex].key);
                            }}
                            onBlur={() => {
                                this.close();
                            }}
                            hotKeyWithArrow={hotKeyWithArrow}
                            disabled={disabled}
                            placeholder={placeholder}
                            autoFocus={autoFocus}
                            onClick={evt => {
                                let { renderInTable } = this.props;
                                if (renderInTable) {
                                    this.setState({ show: true });
                                    onFocus && onFocus(evt, evt.target, list[currentIndex].key);
                                }
                            }}
                            maxlength={maxlength}
                            isCheckChinese={!!maxlength}
                        />
                        <span className="multi-lang-suffix">
                            {list[currentIndex] && list[currentIndex].languageType}
                        </span>
                    </div>
                </NCHotKeys>
            </Dropdown>
        );
    }
}

MultiLangText.MultiOption = MultiOption;

MultiLangText.defaultProps = { container: document.body };
